import type { QueryHookOptions } from "@apollo/client";
import { gql, useQuery } from "@apollo/client";

import type { VariantFragment } from "@shared/data/fragments/VariantFragment/VariantFragment.fragment";

const isBackorderNotificationSubscribed_Shared_Query = gql`
  query isBackorderNotificationSubscribed_Shared_Query($variantId: ID!) {
    viewer {
      variant: node(id: $variantId) {
        ... on Variant {
          id
          isBackorderNotificationSubscribed
        }
      }
    }
  }
`;

interface Variant extends Pick<VariantFragment, "id"> {
  isBackorderNotificationSubscribed: boolean;
}

interface Data {
  viewer: {
    variant: Variant;
  };
}

interface Variables {
  variantId: string;
}

const useIsBackorderNotificationSubscribedQuery = (options: QueryHookOptions<Data, Variables>) =>
  useQuery<Data, Variables>(isBackorderNotificationSubscribed_Shared_Query, options);

export type { Data };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export {
  isBackorderNotificationSubscribed_Shared_Query,
  useIsBackorderNotificationSubscribedQuery,
};
